import React from 'react';
import { Box, Typography, Chip, Tooltip } from '@mui/material';
import { UI_TEXT } from './ExitPlanPage.constants';
import { planChipsContainerStyles, planChipsScrollStyles, planChipStyles } from './ExitPlanPage.styles';
import { getPlanTypeLabel } from '@Utils/planType';

export const PlanChipsSection = ({ createdPlans, activePlanId, onPlanClick, theme }) => {
    if (createdPlans.length === 0) return null;

    // Sort plans by id ascending for consistent numbering
    const sortedPlans = [...createdPlans].sort((a, b) => a.id - b.id);

    return (
        <Box sx={planChipsContainerStyles}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                {UI_TEXT.CURRENT_PLANS}
            </Typography>
            <Box sx={planChipsScrollStyles}>
                {sortedPlans.map((plan, idx) => (
                    <Tooltip key={plan.id} title="View/edit this plan">
                        <Chip
                            label={`${getPlanTypeLabel(plan)} #${idx + 1}`}
                            color={activePlanId === plan.id ? "primary" : (plan.planType === 'EXEMPTION_REQUEST' ? "warning" : "default")}
                            sx={planChipStyles(theme, activePlanId === plan.id)}
                            onClick={() => onPlanClick(plan.id)}
                        />
                    </Tooltip>
                ))}
            </Box>
        </Box>
    );
};